import React from 'react';
import { SectionShell } from './SectionShell';
import { reflections } from '../data/caseStudy';
export function Reflections() {
  return <SectionShell number="09" title="What I’d do differently" tone="light" data-id="element-100" data-mp="w8oz23pd81sm">
      <ol className="grid grid-cols-2 gap-x-16 gap-y-12" data-id="element-101" data-mp="19zkcltat772j">
        {reflections.map((item, index) => <li key={item.title} data-id="element-102" data-mp="1570q26u591ll" data-mpi={index}>
            <p className="font-display text-sm font-semibold tabular-nums tracking-[0.2em] text-ink/40" data-id="element-103" data-mp="155pmo84m1vv0">
              {`0${index + 1}`}
            </p>
            <h3 className="mt-5 font-display text-2xl font-semibold leading-tight tracking-tightest text-ink" data-id="element-104" data-mp="1ewk8xchuwvgg">
              {item.title}
            </h3>
            <p className="mt-4 text-[15px] leading-relaxed text-ink/70" data-id="element-105" data-mp="1sv241va3da8e">{item.body}</p>
          </li>)}
      </ol>
    </SectionShell>;
}